<div class="trainingItemGroupDetailsHolder">

  <p-fieldset legend="Training Item Group Details" class="first-fieldset">
    <p-fieldset legend="General" [toggleable]="true" class="first-fieldset">
      <div class="grid">
        <div class="col-3">
          <app-label labelText="{{ 'Number' }}"></app-label>
          <app-read-only readonlyText="{{ selectedTrainingItemGroupForEdit?.number }}"></app-read-only>
        </div>
        <div class="col-3">
          <app-label labelText="{{ 'Name' }}"></app-label>
          <app-read-only readonlyText="{{ selectedTrainingItemGroupForEdit?.name }}"></app-read-only>
        </div>
        <div class="col-6">
          <app-label labelText="{{ 'eQMS Scope(s)' }}"></app-label>
          <div *ngFor="let eqmsScope of selectedTrainingItemGroupForEdit?.eqmsScopesNames">
            <app-read-only readonlyText="{{ eqmsScope }}" toolTipMessage="{{eqmsScope}}"></app-read-only>
          </div>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="Training Items" class="first-fieldset">
      <app-panel-list class="panelListPlaceHolder" [panelList]="trainingItemGroupListModalInput"
        [noResultFound]="!istrainingItemsLoaded">
        <ng-template #templateRef let-data="dataVar">
          <div panel-content class="grid">
            <div class="col-fixed text-left" style="width: 60%">
              <div class="font-semibold">Training Item</div>
              <div class="mt-1">
                <div class="overflow-ellipse flex-initial flex underline document-header font-semibold ">
                  <a class="training-item-link" (click)="openDocument(data.number,data.version,data.trainingType)">{{
                    data?.number }} {{(data.title.length>90)?
                    (data?.title | slice:0:90)+'..':(data?.title)}} </a>
                </div>
              </div>
            </div>
            <div class="col-fixed text-left" style="width: 10%">
              <div class="font-semibold">Type</div>
              <div class="mt-1">
                {{ data?.trainingTypeName }}
              </div>
            </div>
            <div class="col-fixed text-left" style="width: 10%">
              <div class="font-semibold">Scheduled</div>
              <div class="mt-1">
                {{ data?.scheduledValue }}
              </div>
            </div>
            <div class="col-fixed text-left" style="width: 20%">
              <div class="font-semibold">eQMS Scope(s)</div>
              <div class="mt-1">
                <ul>
                  <li class="content-wrap" *ngFor="let eqmsScope of data?.eqmsScopeNames">
                    {{ eqmsScope }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
      </app-panel-list>
    </p-fieldset>
  </p-fieldset>
</div>